<script setup lang="ts">
const props = defineProps({
  file: null,
  peek: { type: Boolean },
  showMatchedChunks: { type: Boolean }
})
const { file } = toRefs(props)
const { rendererState } = useRenderer({ file })

const searchAnnotations = computed(() => {
  if (!props.showMatchedChunks)
    return
  return props
    .file
    .matchedChunks()
    ?.filter(chunk => chunk.chunkType === "polyEmbedV1Page" && chunk.pageNumber !== undefined)
    .map((chunk: PolyEmbedV1PageMatchedChunk) => chunk.pageNumber!)
})
</script>

<template>
  <div class="renderer-container" :class="{ peek }">
    <pdf-viewer
      v-if="!rendererState.loading && rendererState.objectUrl"
      :url="rendererState.objectUrl"
      :search-annotations
      class="pdf-viewer"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply h-full w-full flex items-center justify-center
  &.peek
    @apply w-[75vw] h-[75vh]

.pdf-viewer
  @apply w-full h-full
  font-feature-settings: normal
</style>

<style lang="sass">
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  #pdf-viewer-main
    --thumbnail-annotation-outline-weight: 3px
    --thumbnail-bg-color: var(--global-blue-primary)
    --thumbnail-font-family: 'Inter', sans-serif
</style>
